import { isApiHttpError } from "../../lib/orvalFetch";

const MAX_USER_FACING_API_ERROR_LENGTH = 500;

function hasUnsafeControlCharacters(value: string): boolean {
  return [...value].some((character) => {
    const code = character.codePointAt(0) ?? 0;

    return (
      (code < 32 && code !== 9 && code !== 10 && code !== 13)
      || code === 127
    );
  });
}

export function presetApplyErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (
    !isApiHttpError(error)
    || error.status < 400
    || error.status >= 500
  ) {
    return fallback;
  }

  const message = error.message.trim();

  if (
    message === ""
    || message.length > MAX_USER_FACING_API_ERROR_LENGTH
    || hasUnsafeControlCharacters(message)
  ) {
    return fallback;
  }

  return message;
}
